import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { tap, take, switchMap, catchError, map, filter } from 'rxjs/operators';

import * as fromStore from '../store';
import { Observable, of } from 'rxjs';
import { SetTitle, SetTags, SetTheme, SetNavTransparency } from '../../store';
import { StringUtility } from '@teamfoster/sdk/text-utility';
import { FromDictionaryPipe, LanguageService } from '@teamfoster/sdk/dictionary-ngrx';

@Injectable({ providedIn: 'root' })
export class ContentPageMetaGuard {
  private store = inject<Store<fromStore.ContentState>>(Store);
  private lang = inject(LanguageService);

  private dict = new FromDictionaryPipe();

  canActivate(): Observable<boolean> {
    return this.checkStore().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkStore(): Observable<boolean> {
    return this.store.select(fromStore.getSelectedContentPage).pipe(
      tap(page => {
        if (!page) {
          return;
        }
        this.store.dispatch(SetNavTransparency({ transparent: !!page.image?.absoluteUrl }));
        this.store.dispatch(
          SetTitle({
            title: `${page?.metaData?.title || page?.title} ${
              this.dict.transform('meta-titel-suffix') ? '- ' + this.dict.transform('meta-titel-suffix') : ''
            }`,
          })
        );
        this.store.dispatch(
          SetTags({
            properties: {
              'description': StringUtility.Truncate(StringUtility.StripHTML(page.metaData.description), 157, '...'),
              'og:image': page.metaData.imageUrl ? `https:${page.metaData.imageUrl}` : '',
              'og:title': `${page.metaData.title} ${this.dict.transform('meta-titel-suffix')}`,
              'og:description': StringUtility.Truncate(StringUtility.StripHTML(page.metaData.description), 157, '...'),
              'keywords': `${page.metaData.keywords?.join(',')}`,
            },
          })
        );
      }),
      filter(a => a?.id > 0),
      map(a => true),
      take(1)
    );
  }
}
